var map = {
	"./aparthotelclub/ic_worldwide_colored.png": 56918,
	"./beachful/ic_worldwide_colored.png": 64691,
	"./castlepedia/ic_worldwide_colored.png": 53321,
	"./cocktayl/ic_worldwide_colored.png": 8034,
	"./ic_worldwide_colored.png": 69249,
	"./luxresortclub/ic_worldwide_colored.png": 14897,
	"./parkful/ic_worldwide_colored.png": 25637,
	"./prefabworld/ic_worldwide_colored.png": 14660,
	"./rooftopclub/ic_worldwide_colored.png": 62829,
	"./spaclub/ic_worldwide_colored.png": 51611,
	"./worldcasino/ic_worldwide_colored.png": 92892,
	"./zoopedia/ic_worldwide_colored.png": 39045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62357;